const U = (id) =>
  `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=85&w=800`;

export const SERVICE_IMAGES = {
  extreme:        U("photo-1584820927498-cfe5211fd8bf"),
  sinistre:       U("photo-1632624759923-86919326bd0f"),
  debarras:       U("photo-1612965110667-4175024b0dcc"),
  particuliers:   U("photo-1581578731548-c64695cc6952"),
  professionnels: U("photo-1497366216548-37526070297c"),
  immeubles:      U("photo-1613545325278-f24b0cae1224"),
  chantier:       U("photo-1591588582259-e675bd2e6088"),
  sols:           U("photo-1584622650111-993a426fbf0a"),
  exterieur:      U("photo-1582268611958-ebfd161ef9cf"),
  espaces_verts:  U("photo-1558904541-efa843a96f01"),
  batiments:      U("photo-1497366811353-6870744d04b2"),
  canapes:        U("photo-1686178827149-6d55c72d81df"),
  tapis:          U("photo-1534889156217-d643df14f14a"),
  vitres:         U("photo-1524803504179-6d7ae4d283f7"),
};
